import { motion, useInView } from "framer-motion";
import { useRef } from "react";

interface TextPanelProps {
  img?: string;
  title?: string;
  subtitle?: string;
  contexts: string[];
}

const TextPanel: React.FC<TextPanelProps> = ({ img, title, subtitle, contexts }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: false, amount: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={{
        hidden: { opacity: 0, y: 0 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: 1, type: "spring", bounce: 0.5 },
        },
      }}
      className="contain w-full h-auto flex flex-col items-start justify-center gap-4 sm:pl-[25px] sm:pr-[10px] pt-[35px] z-10 relative"
    >
      {img && (
        <div className="hidden md:block w-[197px] h-[162px] absolute right-5 top-3">
          <img src={img} alt="Panel" className="w-full h-auto" />
        </div>
      )}

      {title && (
        <div className="border-l-4 border-[#172B6B] px-2 text-[#172B6B] font-bold text-lg sm:text-3xl lg:text-5xl font-bungeeinline">
          {title}
        </div>
      )}

      {subtitle && (
        <div className="sm:w-3/4 font-semibold text-[#F8D835] font-montserrat text-xl sm:text-3xl lg:text-5xl py-2 sm:py-6">
          {subtitle}
        </div>
      )}

      {contexts.map((context, index) => (
        <div key={index} className="ml-4 text-xl sm:text-2xl">
          {context}
        </div>
      ))}
    </motion.div>
  );
};

export default TextPanel;
